<template>
  <div class="customer-header"></div>
</template>

<script>
export default {

}
</script>

<style scoped>
.customer-header{
    height: 60px;
    background: white;
    position: sticky;
    top: 0;
}
</style>